document.addEventListener("DOMContentLoaded", function() {
const trigger = document.getElementById("open-klaviyo-popup");
console.log("Trigger : ", trigger);
if (trigger) {
    // Add click listener to open Klaviyo popup
    trigger.addEventListener("click", function(e) {
    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'WL4u2u']);
    });
}
});